// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2_ciA","filesListContainer":"PosDisputesFiles_filesListContainer__1ksCn","filesButton":"PosDisputesFiles_filesButton__29Cqk"};